import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getServiceShopRequest = createAsyncThunk('/getServiceShopRequest',
  async () => {
    const response = await axios.get('/GetServiceShopRequest');
    return response.data;
  });

export const getEmployeeRequest = createAsyncThunk('/getEmployeeRequest', async (serviceShopId) => {
  const response = await axios.get(`/GetEmployeeRequest/${serviceShopId}`);
  return response.data;
});

export const setEmployeeRequest = createAsyncThunk('/SetEmployeeData', async (req) => {
  const response = await axios.post(`/SetEmployeeData`, req);
  return response.data;
});

export const getEmployees = createAsyncThunk('/getEmployees', async (employeeId) => {
  const response = await axios.get(`/GetEmployees/${employeeId}`);
  return response.data;
});

export const getUserPassword = createAsyncThunk('/getUserPassword', async (UserCode) => {
  const response = await axios.get(`/GetUserPassword/${UserCode}`);
  return response.data;
});

export const getServiceEmployeesAdressPhones = createAsyncThunk('/getServiceEmployeesAdressPhones', async (serviceShopId) => {
  const response = await axios.get(`/GetServiceEmployeesAdressPhones/${serviceShopId}`);
  return response.data;
});

export const getSiriusUserType = createAsyncThunk('/getSiriusUserType',
  async () => {
    const response = await axios.get('/GetSiriusUserType');
    return response.data;
  });

export const getEmployeeRole = createAsyncThunk('/getEmployeeRole',
    async () => {
      const response = await axios.get('/GetEmployeeRole');
      return response.data;
    });

export const getRetailers = createAsyncThunk('/getRetailersRequest', async () => {
      const response = await axios.get('/GetRetailersRequest');
      return response.data;
    });
  
const employeeSlice = createSlice({
  name: 'employee',
  initialState: {
    loading: '',
    error: '',
    JustServiceShop: [],
    EmployeesRequestList: [],
    Employees: [],
    EmployeesAdressPhonesExport: [],
    SiriusUserType: [],
    EmployeeRole: [],
    Password: ''
  },
  reducers: {
  },
  extraReducers: {
    [getServiceShopRequest.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getServiceShopRequest.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getServiceShopRequest.fulfilled]: (state, action) => {
      state.JustServiceShop = action.payload;
      state.loading = 'Finished';
    },
    [getEmployeeRequest.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getEmployeeRequest.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getEmployeeRequest.fulfilled]: (state, action) => {
      state.EmployeesRequestList = action.payload;
      state.loading = 'Finished';
    },
    [setEmployeeRequest.pending]: (state) => {
      state.loading = 'Loading';
    },
    [setEmployeeRequest.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [setEmployeeRequest.fulfilled]: (state, action) => {
      state.EmployeesRequestList = action.payload;
      state.loading = 'Finished';
    },
    [getEmployees.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getUserPassword.pending]: (state) => {
      state.loading = 'Loading';
    },

    [getEmployees.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getUserPassword.rejected]: (state, action) => {
      state.error = action.payload;
    },

    [getEmployees.fulfilled]: (state, action) => {
      state.Employees = action.payload;
      state.loading = 'Finished';
    },
    [getUserPassword.fulfilled]: (state, action) => {
      state.Password = action.payload;
      state.loading = 'Finished';
    },
    [getServiceEmployeesAdressPhones.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getServiceEmployeesAdressPhones.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getServiceEmployeesAdressPhones.fulfilled]: (state, action) => {
      state.EmployeesAdressPhonesExport = action.payload;
      state.loading = 'Finished';
    },
    [getSiriusUserType.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getSiriusUserType.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getSiriusUserType.fulfilled]: (state, action) => {
      state.SiriusUserType = action.payload;
      state.loading = 'Finished';
    },
    [getEmployeeRole.pending]: (state) => {
      state.loading = true;
    },
    [getEmployeeRole.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getEmployeeRole.fulfilled]: (state, action) => {
      state.EmployeeRole = action.payload;
      state.loading = false;
    },
    [getRetailers.pending]: (state) => {
      state.loading = true;
    },
    [getRetailers.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getRetailers.fulfilled]: (state, action) => {
      state.Retailers = action.payload;
      state.loading = false;
    }
  }
});
export const employeeActions = employeeSlice.actions;
export default employeeSlice;
